import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { Flex } from './base/layout-components';
const MIN_VALUE = 2;
const MAX_VALUE = 4;

const Circle = styled(Flex)`
  border-radius: 50%;
  font-size: 1.27rem;
  ${({ size, bgColor, bgOpacity }) => `
  width: ${size}rem;
  height: ${size}rem;
  background: ${bgColor ? getColor(bgColor, bgOpacity) : 'transparent'};
  `}
`;

const getSizesConfig = numOfConfigs => {
  const sizesDiff = (MAX_VALUE - MIN_VALUE) / numOfConfigs;
  const sizesConfig = [MIN_VALUE];
  for (let i = 0; i < numOfConfigs; i++) {
    const val = (Number(sizesConfig[i]) + sizesDiff).toFixed(2);
    sizesConfig.push(val);
  }
  sizesConfig.push(MAX_VALUE);
  return sizesConfig;
};

const getSize = (value, valuesConfig) => {
  const sizesConfig = getSizesConfig(valuesConfig.length);
  const configIndex = valuesConfig.findIndex(configVal => value < configVal);
  const sizeIndex = configIndex === -1 ? sizesConfig.length - 1 : configIndex;
  return sizesConfig[sizeIndex];
};

// values config should be an array of sorted numeric values, representing the range of values for the sizes of the circle.
const RelativeCircle = ({
  displayValue,
  value,
  valuesConfig = [],
  color = 'indigo',
  opacity = 0.1,
  ...other
}) => {
  return (
    <Circle size={MAX_VALUE} items='center' justify='center'>
      <Circle
        items='center'
        justify='center'
        size={getSize(value, valuesConfig)}
        bgColor={color}
        bgOpacity={opacity}
        {...other}
      >
        {displayValue}
      </Circle>
    </Circle>
  );
};

export default RelativeCircle;
